import { useQuery } from '@tanstack/react-query';
import { 
  getCM1ReportData, 
  getCM1TrendData,
  type CM1ReportData 
} from '@/services/cm1ReportService';

export function useCM1Report(startDate: Date, endDate: Date) {
  return useQuery<CM1ReportData>({
    queryKey: ['cm1-report', startDate.toISOString(), endDate.toISOString()],
    queryFn: () => getCM1ReportData(startDate, endDate),
  });
}

export function useCM1Trend(
  startDate: Date, 
  endDate: Date,
  granularity: 'daily' | 'weekly' | 'monthly' = 'daily'
) {
  return useQuery({
    queryKey: ['cm1-trend', startDate.toISOString(), endDate.toISOString(), granularity],
    queryFn: () => getCM1TrendData(startDate, endDate, granularity),
  });
}
